module.exports = __webpack_public_path__ + "fonts/socicon.9a64ef9.ttf";